import React, { useContext } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import UserAliases from './UserAliases'
import UserCmis from './UserCmis'
import UserMembership from './UserMembership'
import { RelationshipCalculatorContext } from '../../relationshipCalculator/RelationshipCalculatorContext'
import { UserContext } from '../UserContext'

export default function UserSummary() {
  usePageView({ page_detail: 'DMConsole:UserSummary' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.user.summary'))
  const relationshipCalculatorContext = useContext(RelationshipCalculatorContext)
  if (relationshipCalculatorContext) relationshipCalculatorContext.summary = true

  const userContext = useContext(UserContext)
  const aliases = userContext?.currentUser?.dmcUser?.aliases
  const mrn = userContext?.currentUser?.dmcUserMembership?.mrn
  return (
    <>
      <UserCmis />
      {aliases?.length > 0 && <UserAliases aliases={aliases} />}
      {mrn != null && <UserMembership />}
    </>
  )
}
